import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import TimeTable from './components/TimeTable'
import config from './config'
import { getSpaceList } from './redux/timeTableSlice'
import { ParamSlug } from '../../types'
import { RootState } from '../../store'
// eslint-disable-next-line import/named
import { getProgramSpacesForDate } from './redux/selectors'
import { _ } from '../../utils/localization'
import { collapse, expand, selectExpandFooter } from './redux/expandFooterSlice'

interface StyledFooterProps {
    height: number
}
interface StyledHeaderTabProps {
    onClick: (e: Event) => void
}

const S = {
    Footer: styled.footer<StyledFooterProps>`
        position: fixed;
        height: ${({ height }) => height}px;
        transition: all .3s ease-in-out;
        bottom: 0;
        left: 0;
        right: 0;
        margin-bottom: 0;
        z-index: 10;
    `,
    HeaderTab: styled.div<StyledHeaderTabProps>`
        position: relative;
        margin-left: auto;
        margin-right: auto;
        margin-top: -${config.tabHeight}px;
        padding-bottom: 3px;
        width: 200px;
        height: ${config.tabHeight}px;
        border-top: black solid;
        // first box shadow is top + right, second is left and a bit smaller
        box-shadow: 3px -3px 2px rgba(0, 0, 0, 0.5),-1px 0 1px rgba(0, 0, 0, 0.5);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background-color: white;
        color: black;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        cursor: pointer;
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            transform: translateX(-50%);
            width: 200vw;
            height: 10px;
            background-color: white;
        }
    `,
    FooterContent: styled.div`
        background-color: white;
        height: auto;
    `,
}

const TimeTableFooter = () => {
    const dispatch = useDispatch()
    const contentRef = React.useRef<HTMLDivElement>()
    const [expandedHeight, setExpandedHeight] = React.useState(0)
    const { eventSlug } = useParams<ParamSlug>()

    const programSpaces = useSelector(getProgramSpacesForDate)
    const spaces = useSelector((state: RootState) => state.timetable.spaces)

    const expanded = useSelector(selectExpandFooter)
    const toggleExpand = () => dispatch(expanded ? collapse() : expand())

    const collapsedHeight = 0
    const height = expanded ? expandedHeight : collapsedHeight

    React.useLayoutEffect(() => {
        setExpandedHeight(contentRef.current.clientHeight)
    }, [programSpaces])

    React.useEffect(() => {
        dispatch(getSpaceList({ eventSlug }))
    }, [dispatch, eventSlug])

    return (
        <S.Footer height={height}>
            <S.HeaderTab onClick={toggleExpand}>
                {_('timetable.timetable')}
            </S.HeaderTab>

            <S.FooterContent ref={contentRef}>
                {
                    spaces.status === 'loading'
                        ? <p>Loading...</p>
                        : <TimeTable programSpaces={programSpaces} expanded={expanded} />
                }
            </S.FooterContent>
        </S.Footer>
    )
}

export default TimeTableFooter
